import { IconProps } from "./Icons";

export const IconArrow = ({
  width = 14,
  height = 9,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M.75 7.5 7 1.25l6.25 6.25"
    />
  </svg>
);
